import * as AwsUi from './AwsUi';
import metrics from '../../utils/src/metrics';
// Those 2 metrics were meant to be logged by mezzanine bar,
// but we could not wait for their release and update propagation
if (typeof window !== 'undefined') {
    metrics.sendMetricOnce('awsui-viewport-width', window.innerWidth || 0);
    metrics.sendMetricOnce('awsui-viewport-height', window.innerHeight || 0);
}
export * from './AwsUi';
export { AwsUi };
//# sourceMappingURL=index.js.map